module.exports = __webpack_public_path__ + "img/nrl-green.141f6497.svg";